import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import * as DOMPurify from 'dompurify';
import  Axios  from 'axios';
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { domain } from '../env';
import { Helmet } from 'react-helmet';
export const WhoWeAre = () => {
    
    const [whoweare,setWhoweare]=useState([])

    const getWhoweare = async () => {
        await Axios({
          method: "get",
          url:`${domain}/api/whowe/`
        }).then(
            response => {
                setWhoweare(response.data)
                console.log(response.data,"wwwwwwwwwwwwwwwwwwwwwwww data .....................")
              
            }
        )
    }
    useEffect(() => {
        getWhoweare()
    }, [])
    
    // Initialize Swiper using existing library after data loads
    useEffect(() => {
        if (whoweare.length > 0 && window.Swiper) {
            setTimeout(() => {
                const whatWeDoSwiper = new window.Swiper('.what-we-do-slider', {
                    slidesPerView: 4, // Show 4 items at once
                    spaceBetween: 30,
                    loop: true,
                    slidesPerGroup: 1, // Slide one item at a time
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false
                    },
                    speed: 1000, // Smooth transition speed
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                        },
                        640: {
                            slidesPerView: 2,
                            slidesPerGroup: 1,
                        },
                        768: {
                            slidesPerView: 3,
                            slidesPerGroup: 1,
                        },
                        1024: {
                            slidesPerView: 4,
                            slidesPerGroup: 1,
                        }
                    },
                    navigation: {
                        nextEl: '.what-we-do-next',
                        prevEl: '.what-we-do-prev',
                    },
                    // Enable infinite loop
                    loopFillGroupWithBlank: false,
                    watchSlidesProgress: true,
                    watchSlidesVisibility: true
                });
            }, 100);
        }
    }, [whoweare])
    
  return (
    <>
        <Helmet>
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/Swiper/5.3.7/css/swiper.min.css" />
            <script src='https://cdnjs.cloudflare.com/ajax/libs/Swiper/5.3.7/js/swiper.min.js'></script>
        </Helmet>
       <section class="we-believe">
            <div class="we-believe-map" style={{'backgroundImage':"url(images/shapes/we-believe-map.png)"}}></div>
            <div class="container">
                <div class="section-title text-center">
                  
                    <h2 class="section-title__title">What We Do ?</h2>
                </div>
                <div class="row who" >
                    <div class="col-xl-12">
                        {/* Slider Navigation */}
                        <div class="text-center mb-4">
                            <button class="what-we-do-prev btn btn-outline-primary me-2">
                                <i class="fa fa-angle-left"></i>
                            </button>
                            <button class="what-we-do-next btn btn-outline-primary">
                                <i class="fa fa-angle-right"></i>
                            </button>
                        </div>
                        
                        {/* Swiper Container */}
                        <div class="swiper-container what-we-do-slider" style={{width: '100%', overflow: 'hidden'}}>
                            <div class="swiper-wrapper">

                      {whoweare && whoweare.map((who, index)=>(
                        <div class="we-believe__single wow fadeInUp swiper-slide" data-wow-delay="100ms" key={index}>
                        <div class="girlstalk">
                            <span >
        <LazyLoadImage 
            effect="blur" 
            src={`${domain}${who?.image}`}
            style={{'height':'150px','borderRadius':'25% 10%','border':'1px solid #a020f0','borderStyle':'dashed'}}
            key={who?.id}
            />
                                {/* <img src='images/g.jpg' style={{'height':'150px','borderRadius':'25% 10%','border':'1px solid #a020f0','borderStyle':'dashed'}} /> */}

                            </span>
                        </div>
                        <h3 class="we-believe__title"><a href={`/whodetails${who?.id}`}>{who?.option_title_english} </a></h3>
                        <p class="we-believe__text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(` ${who?.short_details_english.slice(0,60)}...`)}} /> 
                       
                        <div class="blog-one__bottom">

                            <a  href={`/whodetails${who?.id}`} class="blog-one__btn" style={{'color':'#A020F0'}}>Read More</a>
                            <a href="blog-details.html" class="blog-one__arrow"><span
                                    class="icon-right-arrow"></span></a>
                        </div>
                    </div>

                      ))}
                        
                            
                            {/* <li class="we-believe__single wow fadeInUp" data-wow-delay="200ms">
                                <div class="">
                                    <span>
                                    <img src='images/sdg.jpg' style={{'height':'150px','width':'auto','borderRadius':'25% 10%','border':'1px solid #a020f0','borderStyle':'dashed'}} />
                                    </span>
                                </div>
                                <h3 class="we-believe__title"><a href="contact.html">School camp on SDG- </a></h3>
                                <p class="we-believe__text">Lorem ipsum is simply free text available in the market
                                    wesbites.</p>
                                    <div class="blog-one__bottom">
                                    <a href="blog-details.html" class="blog-one__btn" style={{'color':'#A020F0'}}>Read More</a>
                                    <a href="blog-details.html" class="blog-one__arrow"><span
                                            class="icon-right-arrow"></span></a>
                                </div>
                            </li>
                            <li class="we-believe__single wow fadeInUp" data-wow-delay="300ms">
                                <div>
                                    <span >
                                    <img src='images/safe.jpg' style={{'height':'150px','borderRadius':'25% 10%','border':'1px solid #a020f0','borderStyle':'dashed'}} />
                                    </span>
                                </div>
                                <h3 class="we-believe__title"><a href="volunteers.html">Safety for women- </a></h3>
                                <p class="we-believe__text">Lorem ipsum is simply free text available in the market
                                    wesbites.</p>
                                    <br/>
                                    <div class="blog-one__bottom">
                                    <a href="blog-details.html" class="blog-one__btn" style={{'color':'#A020F0'}}>Read More</a>
                                    <a href="blog-details.html" class="blog-one__arrow"><span
                                            class="icon-right-arrow"></span></a>
                                            <hr/>
                                </div>
                            </li>
                            <li class="we-believe__single wow fadeInUp" data-wow-delay="400ms">
                                <div >
                                    <span >
                                    <img src='images/youth.jpg' style={{'height':'150px','borderRadius':'25% 10%','border':'1px solid #a020f0','borderStyle':'dashed'}} />

                                    </span>
                                </div>
                                <h3 class="we-believe__title"><a href="donations.html">Youth Empowerment- </a></h3>
                                <p class="we-believe__text">Lorem ipsum is simply free text available in the market
                                    wesbites.</p>
                                    <div class="blog-one__bottom">
                                    <a href="blog-details.html" class="blog-one__btn" style={{'color':'#A020F0'}}>Read More</a>
                                    <a href="blog-details.html" class="blog-one__arrow"><span
                                            class="icon-right-arrow"></span></a>
                                </div>
                            </li> */}
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>




        
    </>
  )
}
